export default "__VITE_ASSET__BJIYWB99__"